/** 登录过期跳转前写入，登录页校验 source 后 toast 并删除 */
export const LOGIN_EXPIRED_STORAGE_KEY = 'findin:login-expired';

export type LoginExpiredPayload = {
  source: 'session_expired';
  message: string;
};

export function isLoginExpiredPayload(x: unknown): x is LoginExpiredPayload {
  return (
    typeof x === 'object' &&
    x !== null &&
    (x as LoginExpiredPayload).source === 'session_expired' &&
    typeof (x as LoginExpiredPayload).message === 'string'
  );
}
